export default __webpack_public_path__ + "static/4-bfc666817ebf93bf5fbee191bed400e0.png";